(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-layout-article-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-blog-articles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function shouldUseSlider() {
      return window.innerWidth <= 900;
    }

    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-columns-slider').forEach((el) => {
        if (!shouldUseSlider() || el.classList.contains('blaze-initialized')) return;

        const mobileSlides = parseFloat(el.dataset.blazeMobile) || 1.2;
        const tabletSlides = parseFloat(el.dataset.blazeTablet) || 2.2;
        const loop = el.dataset.blazeLoop === 'true';
        const draggable = el.dataset.blazeDraggable === 'true';

        new BlazeSlider(el, {
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
        });

        el.classList.add('blaze-initialized');
      });
    }

    function destroyBlazeSliders(target = document) {
      target.querySelectorAll('.blaze-initialized').forEach((el) => {
        const track = el.querySelector('.blaze-track');
        if (!track) return;

        const restoredGrid = track.cloneNode(true);
        restoredGrid.className = 'flexi-columns-grid';
        el.parentNode.replaceChild(restoredGrid, el);
      });
    }

    function handleResize() {
      if (shouldUseSlider()) {
        initBlazeSliders();
      } else {
        destroyBlazeSliders();
      }
    }

    handleResize();

    document.addEventListener('shopify:section:load', function (event) {
      handleResize(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-brand-benefits"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-brand-benefits-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: 20,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-collection"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-featured-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    let images = document.querySelectorAll('.flexi-featured-img, .flexi-featured-placeholder-img');
    let currentIndex = 0;

    images[0].style.display = 'block';

    function showNextImage() {
      images[currentIndex].style.display = 'none';
      images[currentIndex].classList.remove('flexi-featured-image-fade');

      currentIndex = (currentIndex + 1) % images.length;
      images[currentIndex].style.display = 'block';
      images[currentIndex].classList.add('flexi-featured-image-fade');

      let loadingBar = document.querySelector('.flexi-loading-bar');
      loadingBar.style.animation = 'none';
      loadingBar.offsetHeight;
      loadingBar.style.animation = '';
    }

    setInterval(showNextImage, 3000);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product-columns"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function shouldUseSlider() {
      return window.innerWidth <= 900;
    }

    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-columns-slider').forEach((el) => {
        if (!shouldUseSlider() || el.classList.contains('blaze-initialized')) return;

        const mobileSlides = parseFloat(el.dataset.blazeMobile) || 1.2;
        const tabletSlides = parseFloat(el.dataset.blazeTablet) || 2.2;
        const loop = el.dataset.blazeLoop === 'true';
        const draggable = el.dataset.blazeDraggable === 'true';

        new BlazeSlider(el, {
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
        });

        el.classList.add('blaze-initialized');
      });
    }

    function destroyBlazeSliders(target = document) {
      target.querySelectorAll('.blaze-initialized').forEach((el) => {
        const track = el.querySelector('.blaze-track');
        if (!track) return;

        const restoredGrid = track.cloneNode(true);
        restoredGrid.className = 'flexi-columns-grid';
        el.parentNode.replaceChild(restoredGrid, el);
      });
    }

    function handleResize() {
      if (shouldUseSlider()) {
        initBlazeSliders();
      } else {
        destroyBlazeSliders();
      }
    }

    // Initial run
    handleResize();

    // On section load (e.g., theme editor)
    document.addEventListener('shopify:section:load', function (event) {
      handleResize(event.target);
    });

    // Debounced resize handler
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product-repeater"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.variantIdInput = this.form.querySelector('[name="id"]');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');
          this.spinner = this.querySelector('.flexi-loading-spinner');
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.quantityInput = this.querySelector('[name="quantity"]');

          this.variantIdInput.disabled = false;

          // Add event listener for the quantity input
          if (this.quantityInput) {
            this.quantityInput.addEventListener('input', this.onQuantityChange.bind(this));
          }

          // Add event listener for the form submission
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        onQuantityChange(evt) {
          // Prevent form submission on quantity change
          evt.preventDefault();
          const quantity = parseInt(evt.target.value, 10) || 1;
          if (quantity < 1) {
            this.quantityInput.value = 1;
          }
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.toggleLoadingState(true);

          const formData = new FormData(this.form);
          const config = {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          };

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          fetch('/cart/add.js', config)
            .then((response) => response.json())
            .then((data) => {
              if (data.status) {
                this.handleErrorMessage(data.description || 'An error occurred.');
                this.toggleSubmitButton(true, 'Sold Out');
                return;
              }

              if (this.cart) {
                this.triggerCartNotification(data);
              } else {
                window.location = '/cart';
              }
            })
            .catch((err) => console.error(err))
            .finally(() => this.toggleLoadingState(false));
        }

        triggerCartNotification(cartData) {
          if (this.cart.tagName.toLowerCase() === 'cart-notification') {
            this.cart.renderContents(cartData);
          } else if (this.cart.tagName.toLowerCase() === 'cart-drawer') {
            this.cart.renderContents(cartData);
            this.cart.classList.add('is-open');
          }
        }

        toggleLoadingState(isLoading) {
          if (isLoading) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            if (this.spinner) {
              this.spinner.classList.add('visible');
            }
            const atcContent = this.submitButton.querySelector('.flexi-atc-content');
            if (atcContent) {
              atcContent.classList.add('hidden');
            }
          } else {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            if (this.spinner) {
              this.spinner.classList.remove('visible');
            }
            const atcContent = this.submitButton.querySelector('.flexi-atc-content');
            if (atcContent) {
              atcContent.classList.remove('hidden');
            }
          }
        }

        handleErrorMessage(errorMessage = '') {
          const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const errorElement = this.querySelector('.product-form__error-message');
          if (!errorWrapper || !errorElement) return;

          if (errorMessage) {
            errorWrapper.hidden = false;
            errorElement.textContent = errorMessage;
          } else {
            errorWrapper.hidden = true;
          }
        }

        toggleSubmitButton(disable, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = 'Add to Cart';
          }
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    const initProductBlazeSliders = () => {
      document.querySelectorAll('.flexi-product-slider').forEach((slider) => {
        // Initialize Blaze Slider
        const sliderInstance = new BlazeSlider(slider, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            loop: false,
            draggable: true,
            slidesToShow: 1.2,
            prevArrow: slider.querySelector('.blaze-prev'),
            nextArrow: slider.querySelector('.blaze-next'),
          },
          '(max-width: 1024px)': {
            slidesToShow: 1.2,
          },
        });
      });
    };

    initProductBlazeSliders();

    document.addEventListener('shopify:section:load', initProductBlazeSliders);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-rotating-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-rotating-images').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            transitionDuration: 200,
            slideGap: '0px',
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-slideshow"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slideshow').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
